'use client';

import { c as _c } from "react/compiler-runtime";
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { css } from '@repo/pandacss/css';
import { Typography } from '@repo/ui/Typography';
import { useEffect, useState } from 'react';
import { useSubmittedAnswers } from '@/features/funnel/state/answer/hooks';
import { useFunnelFlattenedConfig } from '@/features/funnel/state/funnel/Context/hooks';
import { useRecommendations } from '@/features/recommendations/service/useRecommendations';
import { Card } from './Card';
import { DetailsModal } from './DetailsModal';
export function RecommendationList() {
  const $ = _c(22);
  const submittedAnswers = useSubmittedAnswers();
  const funnelFlattenedConfig = useFunnelFlattenedConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isResultsPage: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const recommendations = useRecommendations(funnelFlattenedConfig, t0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSelectedOffer(null);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== submittedAnswers) {
    t2 = [submittedAnswers];
    $[2] = submittedAnswers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (recommendations.length === 0) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      alignSelf: "stretch",
      justifyContent: "center",
      gap: "4",
      my: "3",
      mx: "6"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography as="h2" variant="body.large" css={{
      alignSelf: "flex-start",
      color: "common.white",
      fontWeight: "bold"
    }}>Recommendations so far</Typography>;
    t5 = css({
      display: "flex",
      flexDirection: "column",
      gap: "3",
      listStyle: "none",
      padding: "0",
      margin: "0",
      width: "[100%]"
    });
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== recommendations) {
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = (offer, index) => <li key={offer.id}><Card rank={index + 1} offer={offer} onOpenDetails={setSelectedOffer} /></li>;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t6 = recommendations.slice(0, 3).map(t7);
    $[7] = recommendations;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <ul className={t5}>{t6}</ul>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setSelectedOffer(null);
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== selectedOffer) {
    t10 = <DetailsModal offer={selectedOffer} onClose={t9} />;
    $[17] = selectedOffer;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}